import CardService from 'src/common/api/card.service';

export async function getAllCards({ commit }, { params }) {
  const response = await CardService.getAllCards({ params });
  if (response.status === 200) {
    commit('setAll', { all: response.data });
    return true;
  }
  return false;
}

export async function createCard(context, { type, account }) {
  await CardService.createCard({ type, account });
}

export async function getAllCardsForTransfer({ commit }, { params }) {
  const response = await CardService.getAllCards({ params });
  if (response.status === 200) {
    commit('setAllTransferCards', { transferCards: response.data });
  }
}

export async function transferCredits(context, { cardId, recipient, credits }) {
  const response = await CardService.transferCredits({ cardId, recipient, credits });
  return response.status === 200;
}

export async function raiseCredits(context, { cardId, credits }) {
  const response = await CardService.raiseCredits({ cardId, credits });
  return response.status === 200;
}

export async function decreaseCredits(context, { cardId, credits }) {
  const response = await CardService.decreaseCredits({ cardId, credits });
  return response.status === 200;
}

export async function purchaseCredits(context, { cardId, product }) {
  await CardService.purchaseCredits({ cardId, product });
}

export async function spendCredits(context, { cardId, credits }) {
  await CardService.spendCredits({ cardId, credits });
}

export async function getAllAllocations({ commit }) {
  const response = await CardService.getAllAllocations();
  if (response.status === 200) {
    commit('setAllocations', { allocations: response.data });
  }
}

export async function redeemAllocation(context, { cardId, allocationId, propertyCode }) {
  await CardService.redeemAllocation({ cardId, allocationId, propertyCode });
}

export async function searchCardTransaction({ commit }, { params }) {
  const response = await CardService.searchCardTransaction({ params });
  if (response.status === 200) {
    commit('setAllTransactions', { transactions: response.data.reverse() });
  }
}
